import axios from "axios";

const BASE = "/api/v1/thirteen-week-cash-flow";
const unwrap = (request) => request.then((response) => response.data);

export const thirteenWeekCashFlowApi = {
  getSummary: (params) => unwrap(axios.get(`${BASE}/summary`, { params })),
  // History shares its path with the current request, so it carries its own
  // signal to opt out of the interceptor's same-path auto-cancel.
  getHistory: () =>
    unwrap(axios.get(`${BASE}/summary`, {
      params: { weeks_back: 8 },
      signal: new AbortController().signal,
    })),
  getSettings: () => unwrap(axios.get(`${BASE}/settings`)),
  getCards: () => unwrap(axios.get(`${BASE}/cards`)),
  updateSetting: (key, value) =>
    unwrap(axios.put(`${BASE}/settings`, { key, value })),
  getOverrides: (params) => unwrap(axios.get(`${BASE}/overrides`, { params })),
  saveOverride: (payload) => unwrap(axios.put(`${BASE}/overrides`, payload)),
  deleteOverride: (params) =>
    unwrap(axios.delete(`${BASE}/overrides`, { params })),
  getSchedules: () => unwrap(axios.get(`${BASE}/schedules`)),
  createSchedule: (payload) => unwrap(axios.post(`${BASE}/schedules`, payload)),
  updateSchedule: (payload) => unwrap(axios.put(`${BASE}/schedules`, payload)),
  deleteSchedule: (id) =>
    unwrap(axios.delete(`${BASE}/schedules`, { data: { id } })),
  getTransactions: (params) =>
    unwrap(axios.get(`${BASE}/transactions`, { params })),
  updateTransaction: (id, payload) =>
    unwrap(
      axios.patch(`${BASE}/transactions/${encodeURIComponent(id)}`, payload),
    ),
  bulkUpdateTransactions: (payload) =>
    unwrap(axios.post(`${BASE}/transactions/bulk`, payload)),
  getCategoryRules: () => unwrap(axios.get(`${BASE}/category-rules`)),
  createCategoryRule: (payload) =>
    unwrap(axios.post(`${BASE}/category-rules`, payload)),
  updateCategoryRule: (payload) =>
    unwrap(axios.put(`${BASE}/category-rules/${payload.id}`, payload)),
  deleteCategoryRule: (id) =>
    unwrap(axios.delete(`${BASE}/category-rules`, { data: { id } })),
  getBillcomVendors: (params) =>
    unwrap(axios.get(`${BASE}/billcom-vendors`, { params })),
  getHolidays: () => unwrap(axios.get(`${BASE}/holidays`)),
  createHoliday: (payload) => unwrap(axios.post(`${BASE}/holidays`, payload)),
  deleteHoliday: (id) =>
    unwrap(axios.delete(`${BASE}/holidays`, { data: { id } })),
  getPublishedForecasts: () => unwrap(axios.get(`${BASE}/published-forecasts`)),
  getRevenuePlan: () => unwrap(axios.get(`${BASE}/revenue-plan`)),
  getDisbursements: (params) =>
    unwrap(axios.get(`${BASE}/disbursements`, { params })),
  getDisbursementHistory: () =>
    unwrap(axios.get(`${BASE}/disbursements`, {
      params: { weeks_back: 8, all: 1 },
      signal: new AbortController().signal,
    })),
  importData: (kind, csv, filename) =>
    unwrap(axios.post(`${BASE}/import/${kind}`, { csv, filename })),
};
